module.exports = __webpack_public_path__ + "media/programs/human-program-3f043cf8.png";